// src/pages/AdminDashboard/AdminDashboard.js
import React from 'react';
import { Link } from 'react-router-dom';
import './AdminDashboard.css';

const AdminDashboard = () => {
    return (
        <div className="admin-dashboard page-wrapper">
            <h2>Admin Dashboard</h2>
            <p>Welcome to the admin control panel. Select a tool below:</p>

            <div className="admin-links">
                <Link to="/admin/users" className="admin-button">👥 Manage Users</Link>
                <Link to="/admin/items" className="admin-button">🧩 Review Avatar Items</Link>
                <Link to="/admin/images" className="admin-button">🗑️ Image Deletion</Link>
                <Link to="/moderation" className="admin-button">🚨 Moderation Reports</Link>
            </div>
        </div>
    );
};

export default AdminDashboard;
